import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// The menu (2 Nov 2026, owner). One hamburger button in the header, on every screen size; there is no always-visible strip any more.
//  * Laptop and larger (768px and up): the menu opens beside the page and STAYS open, on every page, until the button is pressed again. The choice is remembered in this browser
//    (localStorage 'menu-open'). The first time, it is closed.
//  * Phone (under 768px): the menu slides over the page and closes by itself when a page is chosen, when the dark area outside it is pressed (the caller does that with setPhoneOpen),
//    on Esc, or with the button again. It is never remembered: it is closed every time.
// Menu items, names and permissions are not touched here: this is only how the menu is shown.
export const MENU_PHONE_BELOW = 768;
const KEY = 'menu-open';

export function useAppMenu() {
  const [isPhone, setIsPhone] = useState(() => window.innerWidth < MENU_PHONE_BELOW);
  const [deskOpen, setDeskOpen] = useState(() => { try { return localStorage.getItem(KEY) === '1'; } catch { return false; } });
  const [phoneOpen, setPhoneOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let framePending = false;
    function apply() { framePending = false; setIsPhone(window.innerWidth < MENU_PHONE_BELOW); }
    function onResize() { if (framePending) return; framePending = true; window.requestAnimationFrame(apply); }   // one update for the burst a drag or a rotation fires
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => { window.removeEventListener('resize', onResize); window.removeEventListener('orientationchange', onResize); };
  }, []);
  useEffect(() => { setPhoneOpen(false); }, [pathname, isPhone]);   // choosing a page, or turning the phone, closes the phone menu
  useEffect(() => {
    if (!isPhone || !phoneOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setPhoneOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isPhone, phoneOpen]);

  function toggleMenu() {
    if (isPhone) { setPhoneOpen((o) => !o); return; }
    setDeskOpen((o) => {
      const next = !o;
      try { localStorage.setItem(KEY, next ? '1' : '0'); } catch { /* not remembered */ }
      return next;
    });
  }
  return { isPhone, deskOpen, phoneOpen, setPhoneOpen, menuOpen: isPhone ? phoneOpen : deskOpen, toggleMenu };
}
